<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="header">
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-0" align="center" justify="space-between" id="header_body">
					<v-col class="ma-0 pa-0" cols="2" id="header_text">
						{{tn('notiTitle')}}
					</v-col>
					<v-col class="ma-0 pa-0" cols="10">
						<v-row class="ma-0 pa-0" align="center" justify="end">
							<v-col class="ma-0 pa-0 pr-4" cols="auto" style="width:10rem;">
								<v-select class="notice_select ma-0 pa-1" v-model="selectedCategory"
									:items="noticeList" dense hide-details outlined 
									dark item-text="label" item-value="value"
								></v-select>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-col>
    <v-col class="pa-0 sticky_body" id="main_content_maxwidthset" cols="12">
			<v-row class="pa-0 ma-0 mt-10 mb-10" justify="center">
        <template v-if="fetchLoading == false">
					<template v-if="filteredNotificationList.length > 0">
						<v-col class="ma-0 pa-0 mb-7" cols="10"
							v-for="(item, index) in filteredNotificationList" :key="index">
							<v-row class="ma-0 pa-0" id="list_date">
								<v-col class="ma-0 pa-0 date_text" cols="auto">
									{{item.date}}
								</v-col>
							</v-row>
							<v-list class="notification_list">
								<v-list-item class="detail_group"
									v-for="(detail, index_detail) in item.subNotificationList"
									:key="index_detail" @click="notiDetailView(detail)">
									<v-list-item-content class="ma-0 pa-0">
										<v-row class="ma-0 pa-0">
											<!-- <v-col class="ma-0 pa-0 mr-10 detail_time" cols="auto">
												{{detail.time}}
											</v-col> -->
											<v-col class="ma-0 pa-0 detail_title" cols="auto">
												{{detail.title}}
											</v-col>
											<v-spacer></v-spacer>
											<v-col class="ma-0 pa-0" cols="auto">
												<v-img src="@/assets/images/right_btn.png" class="ma-0 pa-0"
													max-height="2rem" max-width="2rem"></v-img>
											</v-col>                  
										</v-row>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-col>
					</template>
					<template v-else>
						<v-col class="ma-0 pa-15 mb-7" cols="10">
							{{t('noData')}}
						</v-col>
					</template>
        </template>
        <template v-else>
          <v-col class="ma-0 pa-15 mb-7" cols="10">
            <v-progress-circular indeterminate color="white"
							:width="4" :size="40"></v-progress-circular>
          </v-col>
        </template>
      </v-row>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
// import { NotiTestData } from '../whitetest/sampleData';

const Category = {
  ALL: '1',
  NEWS: '2',
  MAINTENANCE: '3',
  FIRMWARE_UPDATE: '4',
  FAILUERE_INFO: '5'
};

export default {
	components: {
	},
	mixins: [mixin.common],
	data: () => ({
    selectedCategory: Category.ALL,
		// notificationArray: NotiTestData,
    fetchLoading: false,
    notificationList: [],
    filteredNotificationList: [],
		role: '',
	}),
  computed: {
    noticeList() {
      return [
        { label: this.$i18n.t('lang.notification.all'), value: Category.ALL},
        { label: this.$i18n.t('lang.notification.newRelease'), value: Category.NEWS},
        { label: this.$i18n.t('lang.notification.maintenance'), value: Category.MAINTENANCE},
        { label: this.$i18n.t('lang.notification.firmwareUpdate'), value: Category.FIRMWARE_UPDATE},
        { label: this.$i18n.t('lang.notification.failureInformation'), value: Category.FAILUERE_INFO}
      ];
    },
  },
	created() {
		this.role = this.roleCheck(this.$store.getters.getRole);
	},
  mounted() {
    this.fetchData();
		if(this.role == 'private' || this.role == 'branch') this.getDeviceStatus();
    console.group('%cUser Data', "font-size:14px;color:#008DD0;");
      // console.log(JSON.parse(sessionStorage.getItem('auth')));
      console.log('%cUser Detail\n', "color:#008DD0;", this.$store.state.userData.user);
			console.log('%cAuthorities\n', "color:#008DD0;", this.$store.getters.getAuthorities);
    console.groupEnd();
		this.checkCameraAuthResult();
  },
  watch: {
    selectedCategory: {
      handler(val, oldVal) {
        this.filteredNotificationList = this.filterList();
        console.log(this.selectedCategory, this.filteredNotificationList);
      }
    }
  },
  methods: {
    tn(t) {
      return this.$t("lang.notification." + t);
    },
    async notiDetailView(detail) {
      await this.$store.commit('setNotificationDetail', detail);
      this.pushRoute('/notification/detail', {});
    },
    fetchData() {
      this.fetchLoading = true;
			let params = {};
      let setBeginDate = new Date();
      let makeEndingDate = new Date();
      let setEndingDate = new Date(makeEndingDate.setDate(makeEndingDate.getDate() - 30));
			this.networkController.getNotificationInfo(params, 
        this.toIsoStringWithTimeZoneOffset(setEndingDate), this.toIsoStringWithTimeZoneOffset(setBeginDate))
			.then(async (res) => {
				console.log('%cNotification Info Data\n', "color:#008DD0;", res.data);
        let makeList = [];
        let tempDate = '';
        res.data.forEach((item, index) => {
          let updateDate = new Date(`${item.updatedAt.substring(0,4)}-${item.updatedAt.substring(5,7)}-${item.updatedAt.substring(8,10)}`)
          if(index == 0) {
            tempDate = item.updatedAt;
            makeList.push({
              date: this.getFormatDate(updateDate, 'jap'),
              subNotificationList: [{
                title: item.title,
                category: item.category,
                description: item.description,
                updatedAt: item.updatedAt
              }],
              updatedAt: item.updatedAt
            })
          } else {
            if(tempDate == item.updatedAt) {
              let getIndex = makeList.findIndex((element, index, arr) => element.updatedAt === item.updatedAt);
              makeList[getIndex].subNotificationList.push({
                title: item.title,
                category: item.category,
                description: item.description,
                updatedAt: item.updatedAt
              })
            } else {
              tempDate = item.updatedAt;
              makeList.push({
                date: this.getFormatDate(updateDate, 'jap'),
                subNotificationList: [{
                  title: item.title,
                  category: item.category,
                  description: item.description,
                  updatedAt: item.updatedAt
                }],
                updatedAt: item.updatedAt
              })
            }
          }
        });
        setTimeout(() => {
          this.notificationList = makeList;
          this.filteredNotificationList = this.filterList();
          this.fetchLoading = false;
        }, 100);
        console.log(makeList);
			}).catch(error => {
				this.fetchLoading = false;
			});
    },
		getDeviceStatus() {
			let params = {};
			this.networkController.getDashboardDeviceStatusData(params)
			.then(async (res) => {
				console.log('%cDashboard Device Status\n', "color:#008DD0;", res.data);
				const totalAiCameraCnt = res.data.uas.online + res.data.uas.offline;
				if(totalAiCameraCnt < 1) {
					console.log('aiCamera');
					this.$store.commit('setPrivateUserAnalytics', false);
				} else {
					this.$store.commit('setPrivateUserAnalytics', true);
				}
			}).catch(error => { });
		},
    filterList() {
      if (this.selectedCategory === Category.ALL) {
        return this.notificationList;
      } else {
        return this.notificationList.filter(item => item.subNotificationList.some(subItem => subItem.category === this.selectedCategory));
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#header {
	background-color: #272A33;
  position: sticky;
	top: 0;
	z-index: 5;
}
#header_body {
	height: 50px;
}
#header_text {
  font-size: 1rem;
  text-align: left;
}
.sticky_body {
	height: calc(100vh - 150px);
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
  .detail_group > .v-list-item {
    padding-left: 0px;
  }
  .detail_group .v-list-item__icon > i {
    color: white;
    transform: rotate(-0.25turn);
  }
  .v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
  // Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
.notice_select {
  font-size: 0.8em;
}
#list_date {
  text-align: left;
}
.date_text{
  font-weight: 600;
}
.notification_list {
  background: transparent;
  border: none;
}
.detail_group{
  border-bottom: 1px solid #333740;
}
.detail_time {
  color: rgba(255, 255, 255, 0.5);
}
.detail_title {
  color: rgba(255, 255, 255, 0.7);
}

</style>